import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { RecoveryPage } from "@/features/reporting/components/recovery-page";

const layoutRoute = getRouteApi("/_authed/_dashboard/reporting");

export const Route = createFileRoute("/_authed/_dashboard/reporting/recouvrement")({
  component: ReportingRecoveryRoute,
});

function ReportingRecoveryRoute() {
  const search = layoutRoute.useSearch();

  // Pas de période : l'encours se lit sur l'historique complet, cf. RecoveryPage.
  return <RecoveryPage filters={{ tenantId: search.tenantId, companyId: search.companyId }} />;
}
